import { erpApi } from "@/shared/axios/erp-api";
import { urlBackend } from "@/shared/constants";
import { AlertSeverityEnum, IDataSoliLibeValorInstalacion, IDataSoliLibeValorInstalacionParams, ISoliLibeValorInstalacion, UseMutationsParams } from "@/shared/interfaces";
import { getUrlParamsFetch, handleAxiosError } from "@/shared/utils";
import { useUiStore } from "@/store/ui";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

const { get, post, put } = erpApi();


/**
 * Obtener solicitudes de liberacion para valor de instalacion
 * 
*/

export const useFetchGetSolicitudLiberacionValorInstalacion = (params?: IDataSoliLibeValorInstalacionParams) => {

  return useQuery({
    queryKey: ['solicitud-no-cobro-instalacion', ...Object.values(params || {})],
    queryFn: async () => {
      return getSolicitudLiberacionValorInstalacion(params);
    },
    refetchOnWindowFocus: false,
  })
}

export const getSolicitudLiberacionValorInstalacion = async (params?: IDataSoliLibeValorInstalacionParams) => {
  const queryParams = getUrlParamsFetch(params || {});
  const resp = await get<ISoliLibeValorInstalacion>(`${urlBackend}api/v1/solicitud-no-cobro-instalacion/?${queryParams}`, true);
  return resp;
}

/**
 * Crear una solicitud de liberacion
 * 
*/

export const useFetchPostSolicitudLiberacionValorInstalacion = ({
  enableSuccessAlert = true
}: UseMutationsParams) => {
  const queryClient = useQueryClient();
  const setAlert = useUiStore.getState().setAlert;
  const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;

  return useMutation({

    mutationFn: async (params: IDataSoliLibeValorInstalacionParams) => {
      return postSolicitudLiberacionValorInstalacion(params);
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['solicitud-no-cobro-instalacion'] });

      enableSuccessAlert &&
        setAlert &&
        setAlert(
          true,
          data.message,
          AlertSeverityEnum.success
        );

      //setAlert(true, data.message, data.status);
    },
    onError: (e) => {
      handleAxiosError(e)
    },
    onSettled: () => {
      setIsGlobalLoading(false);
    }
  })

}
export const postSolicitudLiberacionValorInstalacion = async (params?: IDataSoliLibeValorInstalacionParams) => {
  const resp = await post<IDataSoliLibeValorInstalacion>(`${urlBackend}api/v1/solicitud-no-cobro-instalacion/`, params, true);
  return resp;
}

/**
 * Actualizar solicitud de liberacion para valor de instalacion
 * 
 * 
*/

export const useFetchPutSolicitudLiberacionValorInstalacion = () => {
  const queryClient = useQueryClient();
  const setAlert = useUiStore.getState().setAlert;
  //const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;

  return useMutation({

    mutationFn: async ({ id, params }: {
      id: string, params: IDataSoliLibeValorInstalacionParams
    }) => {
      return putSolicitudLiberacionValorInstalacion(id, params);
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['solicitud-no-cobro-instalacion'] });
      setAlert(true, data.message, data.status);
    },
    onError: (e) => {
      handleAxiosError(e)
    },
    onSettled: () => {
      //setIsGlobalLoading(false);
    }
  })

}
export const putSolicitudLiberacionValorInstalacion = async (id: string, params: IDataSoliLibeValorInstalacionParams) => {

  const resp = await put<IDataSoliLibeValorInstalacion>(`${urlBackend}api/v1/solicitud-no-cobro-instalacion/${id}/`, params, true);
  return resp;
}